import { render, staticRenderFns } from "./SettingsConfigurationAttachmentTypes.vue?vue&type=template&id=129ea52a&scoped=true&lang=true"
import script from "./SettingsConfigurationAttachmentTypes.vue?vue&type=script&lang=js"
export * from "./SettingsConfigurationAttachmentTypes.vue?vue&type=script&lang=js"
import style0 from "./SettingsConfigurationAttachmentTypes.vue?vue&type=style&index=0&id=129ea52a&prod&lang=scss&scoped=true"
import style1 from "./SettingsConfigurationAttachmentTypes.vue?vue&type=style&index=1&id=129ea52a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129ea52a",
  null
  
)

export default component.exports